import { Type } from "class-transformer";
import { IEntity } from "@interfaces/entity";

export class Role {
  name: string;

  constructor(name: string) {
    this.name = name;
  }
}
